import type React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Radio from '@zg-rentals/multibrand-ui/lib/Radio';
import type { FeedbackInterface } from '@rental-manager/pages/Dashboard/types';
import DebouncedButton from '@common/components/DebouncedButton';

export const RENTER_MOVED_OUT = {
  value: 'RENTER_MOVED_OUT',
  label: 'My renter moved out',
};
export const COLLECT_RENT_OFFLINE = {
  value: 'COLLECT_RENT_OFFLINE',
  label: "I'm going to collect rent offline",
};
export const USE_ANOTHER_SERVICE = {
  value: 'USE_ANOTHER_SERVICE',
  label: "I'm going to use another service",
};

type Props = {
  address: string;
  feedback: FeedbackInterface;
  onChoose: (args: FeedbackInterface) => any;
  onSubmit: () => any;
};

const FeedbackScreen: React.FC<React.PropsWithChildren<Props>> = ({ address, feedback, onChoose, onSubmit }) => (
  <Container>
    <Row>
      <Col>
        <Text type="h3">We value your feedback</Text>
        <Text>Why do you want to stop receiving payments for {address}?</Text>
      </Col>
    </Row>
    <Row>
      <Col>
        <Radio
          label={RENTER_MOVED_OUT.label}
          checked={feedback === RENTER_MOVED_OUT}
          onChange={() => onChoose(RENTER_MOVED_OUT)}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <Radio
          label={COLLECT_RENT_OFFLINE.label}
          checked={feedback === COLLECT_RENT_OFFLINE}
          onChange={() => onChoose(COLLECT_RENT_OFFLINE)}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <Radio
          label={USE_ANOTHER_SERVICE.label}
          checked={feedback === USE_ANOTHER_SERVICE}
          onChange={() => onChoose(USE_ANOTHER_SERVICE)}
        />
      </Col>
    </Row>
    <Row>
      <Col>
        <DebouncedButton full type="primary" onClick={onSubmit}>
          Submit feedback
        </DebouncedButton>
      </Col>
    </Row>
  </Container>
);

export default FeedbackScreen;
